(function ($) {
    $(document).on('click', ".part_item_product_list [data-variant-toggle]", function() {
        let elm = $(this).closest('.part_item_product_list');
        let variants = elm.find("[data-ref-variant]");
        $(this).toggleClass("mod--active");
        variants.stop().slideToggle();
    });
})(jQuery);